import { AIFeature } from 'enums';
import { TeamInsuranceProduct } from 'types';
import WithRouteLocationState from 'broker/components/WithRouteLocationState';
import { RouteKey } from 'broker/enums';
import { AIContextProvider } from 'broker/pages/SubmissionWorkspacePage/contexts/ai/AIContextProvider';
import AcknowledgmentEmailContent from './AcknowledgmentEmailContent';

export interface AcknowledgmentEmailProps {
  onTeamProductsSelected: (products: TeamInsuranceProduct[]) => Promise<void>;
}

export default function AcknowledgmentEmail({ onTeamProductsSelected }: AcknowledgmentEmailProps) {
  return (
    <WithRouteLocationState routeKey={RouteKey.AcknowledgmentEmail} isStateRequired={false}>
      {(locationState) => (
        <AIContextProvider feature={AIFeature.SubmissionAcknowledgment}>
          <AcknowledgmentEmailContent onTeamProductsSelected={onTeamProductsSelected} locationState={locationState} />
        </AIContextProvider>
      )}
    </WithRouteLocationState>
  );
}
